import { render } from "./SolutionView.vue?vue&type=template&id=415343d8"
import script from "./SolutionView.vue?vue&type=script&lang=js"
export * from "./SolutionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__